
import LineChart from "components/charts/LineChart";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getUserDashboardData } from "services/dashboardService";
import { toast } from 'react-toastify';
import { formateDate } from "utils/formatDate";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { Calendar } from "primereact/calendar";
import { useDispatch } from "react-redux";
import { handleLoader } from "redux/counterSlice";
import { element } from "prop-types";

const UserDashboard = () => {
    const dispatch = useDispatch();
    const {
        handleSubmit,
        setValue,
        control,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm<any>()
    const [options, setOptions] = useState({
        chart: {
            id: "basic-bar",
            toolbar: {
                show: false
            },
            fontFamily: "'Inter', sans-serif",
        },
        xaxis: {
            categories: []
        }
    })

    const [docOptions, setDocOptions] = useState({
        chart: {
            id: "basic-bar",
            toolbar: {
                show: false
            },
            stacked: true,
            fontFamily: "'Inter', sans-serif",
        },
        xaxis: {
            categories: []
        }
    })

    const [series, setSeries] = useState([
        {
            name: "",
            data: []
        }
    ])
    const [docSeries, setDocSeries] = useState([
        {
            name: "",
            data: []
        }
    ])
    const [ldOptions, setLdOptions] = useState({
        chart: {
            id: "basic-bar",
            toolbar: {
                show: false
            },
            stacked: true,
            fontFamily: "'Inter', sans-serif",
        },
        xaxis: {
            categories: []
        }
    })
    const [ldSeries, setLdSeries] = useState([
        {
            name: "",
            data: []
        }
    ])
    const [dChartOption, setDChartOption] = useState<any>({
        labels: [],
        legend: {
            position: 'bottom',
            fontFamily: "'Inter', sans-serif",
        },

        plotOptions: {
            pie: {
                donut: {
                    size: '54%'
                }
            }
        }

    })
    const [dashboardOpt, setDashboardOpt] = useState<any>({})
    const [trendQueryOption, setTrendQueryOption] = useState<any>({
        labels: [],
        legend: {
            position: 'bottom',
            fontFamily: "'Inter', sans-serif",
        },

        plotOptions: {
            pie: {
                // donut: {
                size: '54%'
                // }
            }
        }

    })


    const [dChartSeries, setDChartSeries] = useState([])
    const [trendqueryseries, setTrendQuerySeries] = useState([])
    const [isRefresh, setIsRefresh] = useState(false);

    const defaultDate = () => {
        setValue("dates", [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    }
    useEffect(() => {
        let data: any = {}
        data.from_date = formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
        data.to_date = formateDate(new Date())
        data.user_name = localStorage.getItem("username");
        handleDate(data);
        defaultDate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (isRefresh) {
            let data: any = {}
            data.from_date = formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
            data.to_date = formateDate(new Date())
            data.user_name = localStorage.getItem("username");
            handleDate(data);
            setIsRefresh(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRefresh])

    const onSubmit = async (data: any) => {
        if (data.dates && data.dates[0] !== null && data.dates[1] === null) {
            setError('dates', { type: 'custom', message: "Please select end date also", });
        } else {
            data.from_date = formateDate(data.dates[0])
            data.to_date = formateDate(data.dates[1])
            data.user_name = localStorage.getItem("username");
            delete data.dates
            await handleDate(data)
        }
    }

    const handleDate = async (body: any) => {
        dispatch(handleLoader(true));
        try {
            const data = await getUserDashboardData(body)
            if (data.error) {
                throw data.error
            }
            dispatch(handleLoader(false));
            setDChartOption({
                labels: data.topQueries.map((element: any) => {
                    return element.query
                })
            })
            setDChartSeries(data.topQueries.map((element: any) => {
                return element.count
            }))

            setTrendQueryOption({
                labels: data.trendingQueries.map((element: any) => {
                    return element.query
                })
            })
            setTrendQuerySeries(data.trendingQueries.map((element: any) => {
                return element.count
            }))

            setOptions((previousState: any) => ({
                ...previousState,
                xaxis: {
                    categories:
                        data.totalQuerySearch.map((element: any) => {
                            const sDate = new Date(element.date)
                            return moment(element.date).format("MMM") + " " + sDate.getDate()
                        })
                }
            }))
            const temp = data.DocProcessUtilization
            // Use Set to keep track of unique dates
            const uniqueDatesSet = new Set();

            // Reduce the array to unique dates
            const uniqueDatesArray: string[] = temp.reduce((result: any, item: any) => {
                const currentDate = item.query_date;

                // Check if the date is not already in the Set
                if (!uniqueDatesSet.has(currentDate)) {
                    // Add the date to the Set and push it to the result array
                    uniqueDatesSet.add(currentDate);
                    result.push(currentDate);
                }

                return result;
            }, []).slice().sort();
            let finalDatesArray = uniqueDatesArray.map((element: string) => {
                const sDate = new Date(element)
                return moment(element).format("MMM") + " " + sDate.getDate()
            });
            setDocOptions((previousState: any) => ({
                ...previousState,
                xaxis: {
                    categories: finalDatesArray
                }
            }))

            let obj: any = {};
            Object.assign(obj, { TotalUploadedDoc: data.TotalUploadedDoc, SharedWithRepository: data.SharedWithRepository, Qa_count: data.Qa_count });

            setDashboardOpt(obj)
            const dummy = []

            dummy.push({
                name: "query search",
                data: data.totalQuerySearch.map((element: any) => {
                    return element!.count
                })
            })
            setSeries(dummy)

            // Iterate over each object in the array and replace the keys
            const updatedData = temp.map((obj: any) => {
                if (obj.query) {
                    return obj; // If query key exists, return the object unchanged
                } else if (obj.Qa) {
                    // Replace Qa key with query and its value with Qa
                    return { query_date: obj.query_date, query: "Q&A", count: obj.count };
                }
            }).filter((obj: any) => obj !== undefined);
            // Group objects by query_date
            const groupedData = updatedData.reduce((result: any, item: any) => {
                const key = item.query;
                if (!result[key]) {
                    result[key] = [];
                }
                result[key].push(item);
                return result;
            }, {});
            // Convert the groupedData object back to an array
            const groupedArray = Object.entries(groupedData).map(([key, value]) => ({
                query: key,
                items: value,
            }));
            const chatArray = groupedArray.map((item: any) => {
                if (item.query === "Q&A") {
                    const reducedItems = item.items.reduce((acc: any, curr: any) => {
                        const key = curr.query_date;
                        if (!acc[key]) {
                            acc[key] = { ...curr };
                        } else {
                            acc[key].count += curr.count;
                        }
                        return acc;
                    }, {});
                    return { ...item, items: Object.values(reducedItems) };
                }
                return item;
            });
            const tempArr: any = chatArray.map((i: any) => {
                let obj = {
                    name: i.query,
                    // name: i.query !== "undefined" ? i.query : "Q&A",
                    data: uniqueDatesArray.map((date: any) => {
                        const matchingItem = i.items.find((item: any) => item.query_date === date);
                        return matchingItem ? matchingItem.count : 0;
                    })
                    // data: i?.items?.map((j: any) => temp2.includes(j.query_date) ? j.count : 0)
                }
                return obj
            })
            console.log("tempArr", tempArr)
            setDocSeries(tempArr)

            setLdOptions((previousState: any) => ({
                ...previousState,
                xaxis: {
                    categories:
                        data.likeDislike.map((element: any) => {
                            const sDate = new Date(element.date)
                            return moment(element.date).format("MMM") + " " + sDate.getDate()
                        })
                }
            }))

            const like = [{
                name: "Like",
                data: data.likeDislike.map((element: any) => {
                    return element!.like
                })
            }]

            const disLike = [{
                name: "Dislike",
                data: data.likeDislike.map((element: any) => {
                    return element!.dislike
                })
            }]

            setLdSeries([...like, ...disLike])
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    // const calendarRef = useRef(null);
    // const startRef = useRef(null);
    // const handleLabelClick = (e: any) => {
    //     if (calendarRef.current && (calendarRef.current as any).state.open) {
    //         e.preventDefault();
    //     }
    // };
    // const handleLabelClickStart = (e: any) => {
    //     if (startRef.current && (startRef.current as any).state.open) {
    //         e.preventDefault();
    //     }
    // };
    return (
        <div className="p-4 content-wrapper">
            <div className="switch-section user-management-section">
                <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                    <h4 className="mb-0">Dashboard</h4>
                    <div className="d-flex justify-content-between align-items-center table-right-row">
                        <form className="d-flex flex-wrap align-items-start dasboard-head" onSubmit={handleSubmit(onSubmit)}>
                            <div className="table-right-first mr-3 mt-1 mb-1">
                                <Controller
                                    name="dates" // Specify the field name
                                    control={control}
                                    defaultValue={null} // Set the initial value as needed
                                    rules={{ required: "Date is required" }} // Add validation rules here
                                    render={({ field: { onBlur, onChange, value } }) => (
                                        <Calendar
                                            maxDate={new Date()}
                                            value={value}
                                            onChange={(e) => {
                                                onChange(e.value)
                                                clearErrors('dates')
                                            }}
                                            showIcon
                                            icon="pi pi-calendar"
                                            selectionMode="range"
                                            readOnlyInput
                                            hideOnRangeSelection
                                            className="user-input table-search"
                                        />
                                    )}
                                />
                                {errors.dates && <p className="text-danger mb-0">{errors.dates.message as any}</p>}
                            </div>
                            <button className="outline-active-btn mr-3 mt-1 mb-1">Submit</button>
                            <span className="refresh-btn mt-1 mb-1" onClick={() => { defaultDate(); clearErrors('dates'); setIsRefresh(true) }} title="Reset Calender">
                                <i className="fa fa-refresh" ></i>
                            </span>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row chart-overflow">
                <div className="col-lg-4 mb-4 d-flex flex-column justify-content-between">
                    <div className="p-4 bg-white b_col border-1 rounded-4 d-flex round-bg mb-4">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.05" width="64" height="64" rx="32" fill="#013DB9" />
                            <path d="M33.0959 18.2852C25.9418 18.2852 20.1133 24.1137 20.1133 31.2792C20.1133 34.5478 21.3018 37.622 23.4847 40.022L22.5475 44.3305C22.3412 45.3101 23.3724 46.0261 24.2161 45.5761L28.296 43.3476C29.8045 43.9533 31.416 44.2619 33.0959 44.2619C40.2501 44.2619 46.0786 38.4448 46.0786 31.2792C46.0786 24.1137 40.2501 18.2852 33.0959 18.2852ZM33.8959 38.0334C33.4372 38.4922 32.7138 38.4627 32.2845 38.0334C31.823 37.5462 31.8335 36.873 32.2845 36.422C32.7149 35.9916 33.4209 35.947 33.8959 36.422C34.2848 36.8109 34.4002 37.5291 33.8959 38.0334ZM34.7073 31.9535C34.4788 32.045 34.2387 32.2392 34.2387 32.5364V33.2335C34.2387 33.862 33.7245 34.3763 33.0959 34.3763C32.4559 34.3763 31.9531 33.862 31.9531 33.2335V32.5364C31.9531 31.3478 32.7074 30.285 33.873 29.8279C34.833 29.4507 35.3816 28.4679 35.2102 27.4393C35.0731 26.5936 34.3645 25.8736 33.5187 25.7136C32.1409 25.4477 30.9474 26.4872 30.9474 27.8165C30.9474 28.445 30.4331 28.9593 29.8045 28.9593C29.176 28.9593 28.6617 28.445 28.6617 27.8165C28.6617 25.0209 31.2098 22.9374 33.953 23.4622C35.7245 23.8051 37.1758 25.2908 37.473 27.0621C37.8158 29.165 36.6844 31.1764 34.7073 31.9535Z" fill="#013DB9" />
                        </svg>
                        <div className='ps-4'>
                            <h1>{dashboardOpt.Qa_count?.toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</h1>
                            <p className="m-0">Total Queries</p>
                        </div>
                    </div>
                    <div className="p-4 bg-white b_col border-1 rounded-4 d-flex round-bg mb-4">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.05" width="64" height="64" rx="32" fill="#01C324" />
                            <path d="M27.0657 41.7346C26.7726 41.7346 26.5347 41.4968 26.5347 41.2033C26.5347 40.9102 26.7726 40.6724 27.0657 40.6724H37.7746C38.0677 40.6724 38.3056 40.9102 38.3056 41.2033C38.3056 41.4968 38.0677 41.7346 37.7746 41.7346H27.0657ZM27.0657 37.6175C26.7726 37.6175 26.5347 37.3797 26.5347 37.0866C26.5347 36.7935 26.7726 36.5553 27.0657 36.5553H37.7746C38.0677 36.5553 38.3056 36.7935 38.3056 37.0866C38.3056 37.3797 38.0677 37.6175 37.7746 37.6175H27.0657ZM27.0657 33.5004C26.7726 33.5004 26.5347 33.2626 26.5347 32.9695C26.5347 32.6764 26.7726 32.4386 27.0657 32.4386H37.7746C38.0677 32.4386 38.3056 32.6764 38.3056 32.9695C38.3056 33.2626 38.0677 33.5004 37.7746 33.5004H27.0657ZM41.9813 27.8058H35.3898C34.5864 27.8058 33.8538 27.4761 33.3233 26.9452C32.7916 26.4161 32.4627 25.6836 32.4627 24.8778V18.2871H24.7255C24.2124 18.2871 23.7455 18.4975 23.4075 18.8352C23.0698 19.1733 22.8594 19.6402 22.8594 20.1532V24.8325V43.85C22.8594 44.3516 23.0595 44.8082 23.3949 45.1558C23.7455 45.5053 24.2124 45.7157 24.7255 45.7157H24.8245H40.116C40.6283 45.7157 41.0952 45.5049 41.4329 45.1668C41.7709 44.8291 41.9813 44.3626 41.9813 43.85V27.8058ZM33.5245 19.0383V24.8778C33.5245 25.3905 33.7349 25.8574 34.073 26.1954C34.4095 26.5339 34.876 26.7435 35.3898 26.7435H41.2301L35.8411 21.3545L33.5245 19.0383Z" fill="#01C324" />
                        </svg>
                        <div className='ps-4'>
                            <h1>{dashboardOpt.TotalUploadedDoc?.toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</h1>
                            <p className="m-0">Total Uploaded Documents</p>
                        </div>
                    </div>
                    <div className="p-4 bg-white b_col border-1 rounded-4 d-flex round-bg">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.05" width="64" height="64" rx="32" fill="#E54695" />
                            <path d="M41.9794 27.8038H35.3879C34.5844 27.8038 33.8519 27.4741 33.3213 26.9432C32.7896 26.4142 32.4607 25.6816 32.4607 24.8759V18.2852H24.7235C24.2105 18.2852 23.7436 18.4955 23.4055 18.8332C23.0678 19.1713 22.8574 19.6382 22.8574 20.1512V24.8305V43.848C22.8574 44.3496 23.0575 44.8062 23.3929 45.1538C23.7436 45.5033 24.2105 45.7137 24.7235 45.7137H24.8226H40.1141C40.6263 45.7137 41.0932 45.503 41.4309 45.1649C41.769 44.8272 41.9794 44.3607 41.9794 43.848V27.8038ZM33.5226 19.0364V24.8759C33.5226 25.3885 33.733 25.8554 34.071 26.1935C34.4076 26.5319 34.8741 26.7416 35.3879 26.7416H41.2281L35.8392 21.3526L33.5226 19.0364Z" fill="#E54695" />
                            <path d="M28.0931 37.649C28.9643 37.649 29.6705 36.8986 29.6705 35.9729C29.6705 35.0473 28.9643 34.2969 28.0931 34.2969C27.2219 34.2969 26.5156 35.0473 26.5156 35.9729C26.5156 36.8986 27.2219 37.649 28.0931 37.649Z" fill="#E54695" stroke="#FBF2FB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M34.4036 34.2964C35.2748 34.2964 35.9811 33.546 35.9811 32.6204C35.9811 31.6947 35.2748 30.9443 34.4036 30.9443C33.5324 30.9443 32.8262 31.6947 32.8262 32.6204C32.8262 33.546 33.5324 34.2964 34.4036 34.2964Z" fill="#E54695" stroke="#FBF2FB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M34.4036 41.0015C35.2748 41.0015 35.9811 40.2511 35.9811 39.3255C35.9811 38.3998 35.2748 37.6494 34.4036 37.6494C33.5324 37.6494 32.8262 38.3998 32.8262 39.3255C32.8262 40.2511 33.5324 41.0015 34.4036 41.0015Z" fill="#E54695" stroke="#FBF2FB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M29.5137 35.2462L32.9841 33.3467" stroke="#FBF2FB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M29.5137 36.6992L32.9841 38.5987" stroke="#FBF2FB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <div className='ps-4'>
                            <h1>{dashboardOpt.SharedWithRepository?.toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</h1>
                            <p className="m-0">Total Shared Documents</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <div className="mixed-chart round-bg h-100">
                        <h5 className="ps-3 pt-2">Query Search</h5>
                        <LineChart
                            options={options}
                            series={series}
                            type="bar"
                        />
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <div className="donut round-bg h-100">
                        <h5 className="mb-4 ps-3 pt-2">Top 5 Searched Queries</h5>
                        <Chart options={dChartOption} height={300} series={dChartSeries} type="donut" />
                    </div>
                </div>
                <div className="col-lg-6 d-flex flex-column justify-content-between">
                    <div className="donut round-bg mb-4">
                        <h5 className="mb-4 ps-3 pt-2">Trending Queries</h5>
                        <Chart options={trendQueryOption} height={300} series={trendqueryseries} type="pie" />
                    </div>
                    <div className="mixed-chart round-bg mb-4">
                        <h5 className="ps-3 pt-2">Document Processing</h5>
                        <Chart
                            options={docOptions}
                            series={docSeries}
                            height={320}
                            type="bar"
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mixed-chart round-bg">
                        <h5 className="ps-3 pt-2">Feedback</h5>
                        <Chart
                            options={ldOptions}
                            horizontal={true}
                            series={ldSeries}
                            type="bar"
                            height={700}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default UserDashboard